import { type FC, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { ListGroup } from 'react-bootstrap';
import { BsArrowRight, BsArrowLeft, BsTrash } from 'react-icons/bs';
import { columnDropdownStyle, dropdownStyle } from './styles';

interface Props {
	coords: any;
	label: string;
	index: number;
	onAddColumnClick: (_) => void;
	onDeleteColumnClick: (_) => void;
	onClickOutside: () => void;
}

const ColumnOptionsDropdown: FC<Props> = (props) => {
	const { coords, label, index, onAddColumnClick, onDeleteColumnClick, onClickOutside } = props;

	const ref = useRef(null);

	const onAddColumnToTheRight = (index: number) => {
		onAddColumnClick(index + 1);
		onClickOutside();
	};

	const onAddColumnToTheLeft = (index: number) => {
		onAddColumnClick(index);
		onClickOutside();
	};

	const onDeleteColumn = (index: number) => {
		// eslint-disable-next-line no-alert
		if (window.confirm(`Are you sure to delete the column "${label}" ?`)) {
			onDeleteColumnClick(index);
		}
		onClickOutside();
	};

	const handleClickOutside = (event) => {
		if (ref.current && !ref.current.contains(event.target)) {
			onClickOutside();
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	});

	return ReactDOM.createPortal(
		<ListGroup
			className={`${dropdownStyle} ${columnDropdownStyle}`}
			style={{ top: coords.top, left: coords.left }}
			ref={ref}>
			<ListGroup.Item className="dropdownItem" onClick={() => onAddColumnToTheRight(index)}>
				<BsArrowRight /> <span>Add column to the right</span>
			</ListGroup.Item>

			<ListGroup.Item className="dropdownItem" onClick={() => onAddColumnToTheLeft(index)}>
				<BsArrowLeft /> <span>Add column to the left</span>
			</ListGroup.Item>

			<ListGroup.Item
				className="dropdownItem deleteDropdownItem"
				onClick={() => onDeleteColumn(index)}>
				<BsTrash /> <span>Delete column</span>
			</ListGroup.Item>
		</ListGroup>,
		document.querySelector('#editor2-portal-root')
	);
};

export default ColumnOptionsDropdown;
